<template>
  <span v-if="showComponent"
        class="userCounter font-weight-light body-2 grey--text"
        :class="{ 'error--text': userCapacityExhausted, 'font-weight-bold': userCapacityExhausted }"
        :title="$t('License.onZAdmins', { z: adminTotal })"
  >{{ $t('License.xUsersOnYAllowed', { x: userTotal, y:userLimit }) }}</span>
</template>

<style scoped>
  .userCounter {
    margin-left: 15px;
    position: absolute;
    bottom: 15px;
  }
</style>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserCounter',
    computed: {
      ...mapGetters('license', [
        'userLimit',
        'userTotal',
        'adminTotal',
        'userCapacityExhausted'
      ]),
      showComponent() {
        return this.userLimit !== null && this.userTotal !== null
      },
    }
  }
</script>
